import { rootUrlConfig } from '@ui/shared-utils/src/constants'
import { generateMetaData } from '@/config/metadata/metadata'

const oneTrustKey = process.env.VUE_APP_ONETRUST_KEY

export default {
  modules: {
    site: {
      namespaced: true,
      state: {
        sites: {},
        locale: '',
        message: '',
        title: '',
        type: '',
        user: {
          email: '',
          password: ''
        },
        path: ''
      },
      actions: {
        clearMessage ({ commit }) {
          commit('clearMessage')
        },
        setMessage ({ commit }, payload) {
          commit('setMessage', payload)

          if (payload.type === 'danger') {
            window.scrollTo(0, 0)
          }
        },
        setUserCredentials ({ commit }, payload) {
          commit('setUserCredentials', payload)
        },
        setPath ({ commit }, payload) {
          commit('setPath', payload)
        },
        initialise ({ commit }, payload) {
          commit('initialise', payload)
        }
      },
      mutations: {
        clearMessage (state) {
          state.message = ''
          state.type = ''
          state.title = ''
        },
        setMessage (state, payload) {
          state.message = payload.message
          state.type = payload.type
          state.title = payload.title
        },
        setUserCredentials (state, payload) {
          state.user.email = payload.email
          state.user.password = payload.password
        },
        setPath (state, payload) {
          state.path = payload
        },
        initialise (state, payload) {
          state.sites = payload.sites
          state.locale = payload.pseudoLocale
        }
      },
      getters: {
        actualLocale: state => state.sites.actualLocale,
        brand: state => state.sites.site,
        cognitoAppClientId: state => state.sites.cognitoAppClientId,
        cognitoDomainURL: state => state.sites.cognitoDomainURL,
        countryCode: state => state.sites.countryCode,
        cognitoUserPoolId: state => state.sites.cognitoUserPoolId,
        currentRootUrl: state => state.sites.currentRootUrl,
        language: state => state.locale,
        message: state => state.message,
        metaData: state => {
          let canonicalUrl = null
          const { site } = state.sites
          const brandsMapper = {
            tosca: 'asda',
            zava: 'zava',
            sd: 'superdrug'
          }
          const brand = brandsMapper[site] || site
          const rootUrl = rootUrlConfig[brand].production
          if (rootUrl && state.path) {
            const { origin } = new URL(rootUrl)
            canonicalUrl = `${origin}${state.path}`
          }

          return generateMetaData(state.sites.site, state.sites.actualLocale, canonicalUrl)
        },
        oneTrustKey: () => oneTrustKey,
        phoneNumber: state => state.sites.phone,
        privacyLink: state => state.sites.privacyLink,
        recaptchaSiteKey: state => state.sites.recaptchaSiteKey,
        site: state => state.sites.site,
        segmentKey: state => state.sites.segmentWriteKey,
        tcLink: state => state.sites.tcLink,
        title: state => state.title,
        type: state => state.type,
        urlPrefix: state => state.sites.urlPrefix,
        useGoogleSSO: state => state.sites.useGoogleSSO,
        useOneTrust: state => state.sites.useOneTrust,
        userEmail: state => state.user.email,
        userPassword: state => state.user.password
      }
    }
  }
}
